
import CommonPopup from "@/components/CommonPopup.vue";
import { RelUgcProductVO } from "@/views/biz/ugc/vo/ugc.vo";
import axios from "axios";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class FeedProductSearchPop extends CommonPopup {
  inputKeyword = ""; // 입력하고 있는 키워드

  @Prop()
  selectProducts!: Array<RelUgcProductVO>;

  // data
  products: Array<RelUgcProductVO> = [];
  feedProducts!: Array<RelUgcProductVO>;
  // Infinite scroll data
  busy = false;

  // 비주문 상품 목록
  search(loadMore?: boolean) {
    this.busy = true;

    if (!loadMore) {
      this.products = [];
    }

    const params = {
      keyword: this.inputKeyword,
      orderBy: this.inputKeyword ? null : "recommend", // 추천순/가격순
      pageStart: this.products.length,
      ugcTypeCd: '047002'
    };

    axios.post("/products", params).then((r) => {
      this.products = this.products.concat(r.data as Array<RelUgcProductVO>);
      if (r.data.length) {
        this.busy = false;
      }
    });
  }

  // 비주문 상품 목록 더보기
  onLoadMore() {
    this.search(true);
  }

  choiceProduct(): void {
    if(this.feedProducts.length < 1){
      // "a0005": "상품을 선택해주세요."        
      return alert(this.$t('feed.a0005').toString())
    }
    //상품 10개 이상일 시 false
    if(this.feedProducts.length > 10){
      //"a0009": "상품은 최대 10개까지 등록가능합니다."
      return alert(this.$t('feed.a0009').toString())
    }
    this.$emit('update:products', this.feedProducts);
    this.$emit('update:opened', false);
  }

  // initialized events
  @Watch('opened')
  onOpened(): void {
    this.feedProducts = this.selectProducts;
    if(this.opened) {
      this.products = [];
      this.inputKeyword = "";
    }
  }
}
